<div class="container">
    <table mat-table [dataSource]="variables()" class="mat-elevation-z8">
        <!-- Colonne 'Nom' -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="column-name">Nom</th>
            <td mat-cell *matCellDef="let element" class="column-name">{{ element.name }}</td>
        </ng-container>

        <!-- Colonne 'Type' -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="column-type">Type</th>
            <td mat-cell *matCellDef="let element" class="column-type">{{ variableTypes.get(element.type) }}</td>
        </ng-container>

        <!-- Colonne 'Valeur' -->
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="column-value">Valeur</th>
            <td mat-cell *matCellDef="let element" class="column-value">{{ element.value }}</td>
        </ng-container>

        <!-- Colonne 'Actions' -->
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="column actions" class="action-column">
                <button mat-icon-button class="accent-button" [disabled]="disabled" (click)="onCreateVariable()" aria-label="Ajouter une variable">
                    <mat-icon>add</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let element" class="action-column">
                <button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ element: element }" aria-label="Menu contextuel">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-element="element">
            <button mat-menu-item [disabled]="disabled" (click)="onEditVariable(element)">
                <mat-icon>edit</mat-icon>
                <span>Editer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDeleteVariable(element)">
                <mat-icon>delete</mat-icon>
                <span>Supprimer</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
